import styled, {keyframes} from 'styled-components';
import {Box, Button} from '@material-ui/core';

const getRoundedButtonColor = (isActive: boolean) => isActive ? '#A94747' : '#0C995E';

interface RoundedButtonProps {
    isLoading: boolean;
    isActive: boolean;
}

export const RoundedButton = styled(Button).attrs({
    variant: 'outlined',
})`
  height: 28px;
  border-radius: 32px !important;
  padding: 5px 10px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  white-space: nowrap;
  width: ${({isLoading}: RoundedButtonProps) => isLoading ? '20px' : '172px'} !important;
  border-color: ${({isActive}: RoundedButtonProps) => getRoundedButtonColor(isActive)} !important;
  color: ${({isActive}: RoundedButtonProps) => getRoundedButtonColor(isActive)} !important;
  background-color: ${({isActive}: RoundedButtonProps) => `${getRoundedButtonColor(isActive)}20`} !important;
  transition: background-color 0.3s linear, width 0.3s !important;

  &:hover {
    background-color: ${({isActive}: RoundedButtonProps) => `${getRoundedButtonColor(isActive)}30`} !important;
  }
`;

export const RoundedButtonWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  width: 172px;
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const Loader = styled.span`
  width: 20px;
  height: 20px;
  border: 2px solid #616161;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: ${rotate} 1s linear infinite;
`;
